module.exports = __webpack_public_path__ + "static/media/close.ec67fb6a.svg";